import React, { Suspense } from 'react';

import type { ProviderEntry } from '../types';

interface DynamicProviderWrapperProps {
    providers: ProviderEntry[];
    children: React.ReactNode;
    fallback?: React.ReactNode;
}

export const DynamicProviderWrapper: React.FC<DynamicProviderWrapperProps> = ({
    providers,
    children,
    fallback = null,
}) => {
    // Base case: If no providers are left, render the children
    if (providers.length === 0) {
        return <>{children}</>;
    }

    const [currentProvider, ...restProviders] = providers;
    const ProviderComponent = currentProvider.component;

    return (
        <Suspense fallback={fallback}>
            <ProviderComponent key={currentProvider.key} config={currentProvider.config}>
                <DynamicProviderWrapper providers={restProviders} fallback={fallback}>
                    {children}
                </DynamicProviderWrapper>
            </ProviderComponent>
        </Suspense>
    );
};
